import apiClient from "./axios"

// ✅ Get car care service centers (with filters / pagination)
export const getCarCareServiceCenters = async (params = {}) => {
  const { data } = await apiClient.get("/car-care-service-centers", { params })
  return data
}

// ✅ Get single car care service center by ID
export const getCarCareServiceCenter = async id => {
  const { data } = await apiClient.get(`/car-care-service-centers/${id}`)
  return data
}

// ✅ Create car care service center
export const createCarCareServiceCenter = async payload => {
  const { data } = await apiClient.post("/car-care-service-centers", payload)
  return data
}

// ✅ Update car care service center
export const updateCarCareServiceCenter = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(
    `/car-care-service-centers/${id}`,
    payload
  )
  return data
}

// ✅ Soft delete
export const deleteCarCareServiceCenter = async id => {
  const { data } = await apiClient.delete(`/car-care-service-centers/${id}`)
  return data
}
